export default "__VITE_ASSET__D_z0_hYg__"